import { render, staticRenderFns } from "./AbortoProtocoloInteiroModal.vue?vue&type=template&id=01a370e6&scoped=true&"
import script from "./AbortoProtocoloInteiroModal.vue?vue&type=script&lang=js&"
export * from "./AbortoProtocoloInteiroModal.vue?vue&type=script&lang=js&"
import style0 from "./AbortoProtocoloInteiroModal.vue?vue&type=style&index=0&id=01a370e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a370e6",
  null
  
)

export default component.exports